import Config from '../../config';

import Collection from '../../collection';
import Model from '../../model/model';

import { fmt, unixts, datify, parseYYYYMMDD } from '../../utils/date';





export default Collection.extend( {

    responseAt: 'items',
    countAt: 'total',

    model: Model.extend( {

        customParser(payload) {
            const { task } = payload;
            if (task)
                task.date = datify( task.date ),
                task.update_date = datify( task.update_date );

            return payload;
        }

    } ),

    url({ filters: { timetableId, date, time }/*, page, activeId */}) {
        const url = time 
            ? `timetables/${timetableId}/tasks/${fmt( date, 'YYYY-MM-DD' )}/@/${time.replace( ':', '-' )}?apiVersion=2.0`
            : `timetables/${timetableId}/tasks/${fmt( date, 'YYYY-MM-DD' )}?apiVersion=2.0`;

        return Config.url( url );
    },

    parseResponse(modelsAttrs/*, response*/) {
        return modelsAttrs
            // generate id by client-side to avoid duplicating server id if there are many tasks per template
            .map( attrs => ({ ...attrs, id: Math.random() * 1e12 | 0 }) )
            .sort( (a, b) => {
                if (a.run.date < b.run.date)
                    return -1;
                else if (a.run.date > b.run.date)
                    return 1;
                else if (a.run.time < b.run.time)
                    return -1;
                else if (a.run.time > b.run.time)
                    return 1;
    
                const aTitle = a.template.title || '',
                    bTitle = b.template.title || '';
    
                if (aTitle.toLowerCase() < bTitle.toLowerCase())
                    return -1;
                if (aTitle.toLowerCase() > bTitle.toLowerCase())
                    return 1;
    
                /*const scheduleIdDiff = a.run.schedule.id - b.run.schedule.id;
                if (scheduleIdDiff)
                    return scheduleIdDiff;*/
    
                return a.template.id - b.template.id;
            } );
    },
} );


// WEBPACK FOOTER //
// ./src/js/collection/schedule/tasks.js